	//Accordian
	$('.accordion').each(function () {
	    var $accordian = $(this);
	    $accordian.find('.accordion-head').on('click', function () {
	        $accordian.find('.accordion-body').slideUp();
	        if (!$(this).next().is(':visible')) {
	            $(this).next().slideDown();
                   $('h4 span',this).text("-");
            }else{
                $('h4 span',this).text("+");
            }
	    });
	});